"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tag = _interopRequireDefault(require("../Tag/Tag"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TagsGroup = props => {
  const tags = props.items.map(item => /*#__PURE__*/_react.default.createElement(_Tag.default, {
    key: `${item.label}-${item.type}`,
    label: item.label,
    type: item.type,
    onClick: item.onClick
  }));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'tags-group'
  }, tags);
};
TagsGroup.propTypes = {
  items: _propTypes.default.array.isRequired
};
var _default = exports.default = TagsGroup;